import { action, runInAction, observable, computed } from 'mobx';
import _ from 'lodash';
import { dispatch } from 'rfx-core';
import Promise from 'bluebird';

import BaseUploader from './BaseUploader';

export default class AttendanceViolationCountUploader extends BaseUploader {
  constructor() {
    super({ title: 'ui.userOnboardingUploader' });

    return this;
  }

  @observable saveConfirmMessage = '';

  @observable
  parsedHeaders = [];

  @computed
  get sampleCSVData() {
    return [this.knownHeaders, ['userId1', 0]];
  }

  @computed
  get knownHeaders() {
    return ['userId', 'count'];
  }

  @observable saveButtonText = 'Save';

  @observable
  list = [];

  @action
  async parse({ rows }) {
    const caseHeaders = _.map(rows[0], _.toLower);
    this.parsedHeaders = this.knownHeaders;
    const indices = _.reduce(
      this.knownHeaders,
      (acc, header) => {
        acc[header] = _.indexOf(caseHeaders, _.toLower(header));
        return acc;
      },
      {},
    );

    this.log.debug('Loaded Table Indices', { indices });

    const validRows = _(rows)
      .map((row, i) => {
        if (!i) return null;

        this.log.debug(row);

        return _.chain(this.knownHeaders)
          .reduce((acc, colKey) => {
            const colIndex = indices[colKey];

            if (colIndex >= 0) {
              acc[colKey] = row[colIndex];
            }
            return acc;
          }, {})
          .value();
      })
      .reject((rowObj) => _.isEmpty(_.omitBy(rowObj, _.isEmpty)))
      .compact()
      .value();

    this.setStatus('Evaluating');

    runInAction(() => {
      this.list.replace(validRows);
    });

    this.setStatus('Parsed all Rows');
    return null;
  }

  @action
  async processAttendanceViolationCountRow(row, companyId) {
    return dispatch('users.update', {
      data: {
        'companyStatus.$.attendanceViolationCount': _.toNumber(
          _.trim(row.count),
        ),
        'companyStatus.$.attendanceViolationCountManualTimestamp': new Date(),
      },
      id: _.trim(row.userId),
      query: {
        companyStatus: { $elemMatch: { company: companyId } },
      },
    });
  }

  @action
  async save() {
    this.setStatus('saving');
    this.setSaving(true);
    this.saveResults = {
      ignored: [],
      invalid: [],
      new: [],
      updated: [],
    };

    try {
      const response = await Promise.map(
        this.list,
        async (row) => {
          try {
            const company = dispatch('companies.retrieve', 'selected');
            const updatedUser = await this.processAttendanceViolationCountRow(
              row,
              company?.uuid,
            );
            runInAction(() => {
              this.saveResults.new.push(updatedUser);
            });
            return updatedUser;
          } catch (error) {
            this.log.debug(error);
            runInAction(() => {
              this.saveResults.invalid.push(_.extend(row, { err: error }));
            });
            return row;
          }
        },
        { concurrency: 20 },
      );

      runInAction(() => {
        this.list.replace(response);
        this.setStatus('saved');
      });
    } catch (err) {
      this.log.error('Failed to edit attendanceViolationCounts', err);
      dispatch('ui.snackBar.error', `Sorry, something went wrong, ${err}`);
      this.setStatus('error');
      this.clear();
    }

    this.setSaving(false);
    return null;
  }

  @action
  clear() {
    super.clear();

    this.saveResults = {
      ignored: [],
      invalid: [],
      new: [],
      updated: [],
    };

    this.list.clear();
    this.parsedHeaders.clear();
  }
}
